"use client";
import {
  usePopoverDisclosureArrow
} from "./DR55NYVS.js";
import {
  useSelectContext
} from "./KPEX55MY.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./LMDWO4NN.js";
import {
  __objRest,
  __spreadValues
} from "./3YLGPPWQ.js";

// src/select/select-arrow.tsx
var TagName = "span";
var useSelectArrow = createHook(
  function useSelectArrow2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useSelectContext();
    store = store || context;
    props = usePopoverDisclosureArrow(__spreadValues({ store }, props));
    return props;
  }
);
var SelectArrow = forwardRef(function SelectArrow2(props) {
  const htmlProps = useSelectArrow(props);
  return createElement(TagName, htmlProps);
});

export {
  useSelectArrow,
  SelectArrow
};
